import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f06feca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "score-item-text__label"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { key: 3 }

import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'score-item-text',
  props: /*#__PURE__*/_mergeModels({
    readonly: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

  const props = __props;

  const value = _useModel(__props, "modelValue");

  const valueLines = computed(() => {
    return typeof(value.value) === 'string' ? value.value.split(/\r?\n/) : value.value;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["score-item-text", {'score-item-text--extra-top-space': !!__props.label}])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    (__props.readonly && value.value != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["score-item-text__text-readonly", {'score-item-text__text-readonly--light': __props.light}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueLines.value, (line, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createTextVNode(_toDisplayString(line), 1),
              _hoisted_2
            ], 64))
          }), 128))
        ], 2))
      : (!__props.readonly)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 2,
            rows: "5",
            class: "score-item-text__textarea",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
          }, null, 512)), [
            [_vModelText, value.value]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_3, "‐"))
  ], 2))
}
}

})